module.exports = __webpack_public_path__ + "img/gvl-logo.abf4925c.svg";